import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "activity_name" }
const _hoisted_2 = { class: "icon_wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "redPoint"
}
const _hoisted_5 = ["src"]

import { playClickSound } from '@/utils/media';
import { goToRedirectPath, PromotionItem } from '@/view/promotion/supporrtScript';
import { ref, computed, PropType } from 'vue';
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'promotionCardNew',
  props: {
    itemData: {
         type: Object as PropType<PromotionItem>,
        default: () => ({
            name: '',
            unclaimed_count: 0,
            image: '',
            icon: ''
        }),
        required: true
    },
    unClaimedCount: {
        type: Number,
        default: () => 0
    }
},
  emits: ["openAgentPopup", "openRedEnvelop", "goToHome", "openPWA"],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const props = __props
const isPopping = ref(false)

const unclaimed_count = computed(() => props.unClaimedCount)
const emits = __emit

const goToPath = () => {
    goToRedirectPath(isPopping, props.itemData, router, emits, playClickSound)
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card_container", { 'pop-animate': isPopping.value }]),
    onClick: goToPath
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(`activityName.${props.itemData.name}`)), 1),
    _createVNode(_component_van_row, {
      class: "bottom_part",
      gutter: "15"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "4",
          class: "left_col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: props.itemData.activity_icon,
                alt: "",
                class: "iconshake"
              }, null, 8, _hoisted_3),
              (unclaimed_count.value > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(unclaimed_count.value), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "20",
          class: "right_col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: props.itemData.image,
              alt: ""
            }, null, 8, _hoisted_5)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 2))
}
}

})